import { useContext, useEffect, useState } from '@wordpress/element';
import { CampoInput } from '@componentsNew/Input/CampoInput';
import EstruturaPostContext from '@pages/DicasOtimizacao/Context/EstruturaPostContext';

function TituloSeo({ nota, carregando }) {

  return (
    <>
      <CampoInput
        multilinhas={true}
        label={'Título Seo'}
        nota={nota}
        carregando={carregando}
        campoEstrutura={'title_seo'}
      />
    </>
  );
}

export default TituloSeo;
